import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ExchangeableTypeOption } from '../../../../_models/steps';

@Component({
  moduleId: module.id.toString(),
  selector: 'exchangeable-type-confirm-popup',
  templateUrl: './exchangeable-type-confirm-popup.component.html',
  styleUrls: ['./../step-exchangeable-products.component.scss'],
})
export class ExchangeableTypeConfirmPopup implements OnInit {
  @Input('data') inputData: { currentType: ExchangeableTypeOption; nextType: ExchangeableTypeOption };
  @Output('save') onSave: EventEmitter<any> = new EventEmitter<any>();
  @Output('cancel') onCancel: EventEmitter<any> = new EventEmitter<any>();

  constructor() {}

  ngOnInit() {}

  onConfirm() {
    this.onSave.emit({ nextType: this.inputData.nextType });
  }
}
